import { render, staticRenderFns } from "./OnboardingFrontdoc.vue?vue&type=template&id=6d033241&scoped=true"
import script from "./OnboardingFrontdoc.vue?vue&type=script&lang=js"
export * from "./OnboardingFrontdoc.vue?vue&type=script&lang=js"
import style0 from "./OnboardingFrontdoc.vue?vue&type=style&index=0&id=6d033241&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d033241",
  null
  
)

export default component.exports